import { useLocale } from "../context/locale";
import translations from "./translations";

function lookup(dict, path) {
  let node = dict;
  for (const part of path.split(".")) {
    node = node?.[part];
    if (node === undefined) return undefined;
  }
  return node;
}

// t("home.heroTitleLine1") → current language's string, or English's
// if the current language doesn't have that key yet, or the raw key
// itself as a last resort (so a missing translation never renders
// blank — it renders visibly wrong instead, easy to spot and fix).
export function useTranslation() {
  const { language } = useLocale();

  const t = (path) => {
    const inCurrent = lookup(translations[language], path);
    if (inCurrent !== undefined) return inCurrent;

    const inEnglish = lookup(translations.en, path);
    if (inEnglish !== undefined) return inEnglish;

    return path;
  };

  return { t, language };
}
